import { CONSTANTS } from 'src/redux';
import httpClient from 'src/helpers/httpClient';

export const TYPES = {
  LIST_MENUS: 'MENU::LIST_MENUS',
};

const list = (page = 1) => async (dispatch) => {
  dispatch({
    type: TYPES.LIST_MENUS,
    status: CONSTANTS.STATUS.FETCHING
  });
  try {
    const client = await httpClient();
    const response = await client.get(`menu?page=${page}`);
    dispatch({
      type: TYPES.LIST_MENUS,
      status: CONSTANTS.STATUS.DONE,
      payload: response.data
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: TYPES.LIST_MENUS,
      status: CONSTANTS.STATUS.FAILED
    });
  }
};

const actions = {
  list
};

export default actions;
